import React, { Component } from 'react';
import { Flex, Box } from 'reflexbox';
import PropTypes from 'prop-types';
import Text from 'components/Text';

// Favourites components
import Notify from 'Favourites/components/Notify';
import OrderTotal from 'Favourites/components/OrderTotal';
import VatSelector from 'Favourites/components/VatSelector';

// Shoppinglist components
import AddAllToBag from './components/AddAllToBag';
import ListSelector from './components/ListSelector';
import Tabs from './components/Tabs';
import StoreSelector from './components/StoreSelector';
import CollectionOptions from './components/CollectionOptions';
import ProductList from './components/ProductList';
import { LIST_TYPE } from 'Favourites/store/constants';

// CSS
import './shoppingList.styles.scss';

export default class ShoppingList extends Component {
    componentDidMount() {
        const { triggerShoppingListViewChange } = this.props;
        document.body.classList.add('checkout-shoppinglist');
        window.scrollTo(0, 0);

        if (window.Checkout.settings.favourites.default_view) {
            triggerShoppingListViewChange(window.Checkout.settings.favourites.default_view);
        }

        window.Checkout.analytics.setPersistentCustom('page_type', LIST_TYPE);
    }

    componentWillUnmount() {
        window.Checkout.analytics.setPersistentCustom('page_type', null);
        document.body.classList.remove('checkout-shoppinglist');
    }

    render() {
        const { excludeVAT, view } = this.props;

        return (
            <Flex align="center" column className="shoppinglist">
                <Notify />
                <Box w={[1, 1, 768]} pt={2} px={2}>
                    <ListSelector />
                    <Tabs />
                    <Box mt={2}>
                        <StoreSelector />
                    </Box>
                    {excludeVAT && window.Checkout.settings.show_exclude_vat_notification &&
                        <Flex className="shoppinglist__vat-info">
                            <span><Text textKey="product_list_exclude_vat_notification" /></span>
                        </Flex>
                    }
                    <ProductList />
                    <OrderTotal />
                    <OrderTotal withFamilyDiscount />
                    <Box pt={2}>
                        <VatSelector />
                    </Box>
                    {!window.Checkout.settings.favourites.disable_add_all_on_view.includes(view) &&
                        <AddAllToBag />
                    }
                    <CollectionOptions />
                </Box>
            </Flex>
        );
    }
}

ShoppingList.propTypes = {
    excludeVAT: PropTypes.bool,
    triggerShoppingListViewChange: PropTypes.func,
    view: PropTypes.string,
};
